<template>
  <div class="resources-listing" :class="{ 'filters-visible': switchersData.filtersVisible }">
    <div class="filters">
      <Search
        v-model="searchPhrase"
      />

      <Switchers 
        v-model="switchersData"
        @updateFilters="updateFilters"
        @updateResources="updateResources"
      />
    </div>

    <ResourcesList 
      :filteredResources="filteredResources" 
      :countPerPage="countPerPage" 
      :pageNum="pageNum"
    />

    <Pagination 
      :filteredResourcesCount="filteredResources.length" 
      :countPerPage="countPerPage"
      v-model="pageNum" 
    />
</template>

<script>
import { mapActions } from 'vuex'
import { mapState } from 'vuex'
import content from '@/translations/content'

import ResourcesList from '@/components/ResourcesList'
import Pagination from '@/components/Pagination'
import Search from '@/components/Search'
import Switchers from '@/components/Switchers'

export default {
  name: 'App',
  mixins: [ content ],
  components: { ResourcesList, Pagination, Search, Switchers },
  data() {
    return {
      filteredResources: [],
      switchersData: Object,
      searchPhrase: '',
      countPerPage: 8,
      pageNum: 0
    }
  },
  methods: {
    ...mapActions([
      'refreshResources',
      'refreshTopics',
      'refreshResourceTypes',
      'refreshLanguages'
    ]),
    filterResources() {
      this.filteredResources = this.resources.filter(resource => (resource.title.toLowerCase().indexOf(this.searchPhrase.toLowerCase()) !== -1) 
      && ((this.switchersData.topicTid == 0 || this.switchersData.topicTid == null) || (resource.topic && resource.topic.some(item => item == this.switchersData.topicTid))) 
      && ((this.switchersData.resourceTypeTid == 0 || this.switchersData.resourceTypeTid == null) || (resource.resource_types && resource.resource_types.some(item => item == this.switchersData.resourceTypeTid))))
    },
    updateFilters() {
      this.pageNum = 0
      this.filterResources()
    },
    updateResources() {
      this.pageNum = 0
      this.$store.commit('setLanguage', { lang: this.switchersData.languageId })

      Promise.all([
        this.refreshResources(), 
        this.refreshTopics(), 
        this.refreshResourceTypes()
      ]).then(() => this.filterResources())
    }
  },
  created() {
    this.refreshTopics()
    this.refreshResourceTypes()
    this.refreshLanguages()
    this.refreshResources()
      .then(resp => this.filteredResources = resp.data)
  },
  computed: {
    ...mapState(['resources'])
  },
  watch: {
    searchPhrase: function () {
      this.pageNum = 0
      this.filterResources()
    }
  }
}
</script>